export default "__VITE_ASSET__DQNyPteo__"